
/* injects from baggage-loader */

'use strict';

export default class AccountWidgetController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
